import React from 'react';

const Reports = () => {
  return (
    <div>
      <h2>Reports</h2>
      <p>Here you can view and manage your reports.</p>
    </div>
  );
};

export default Reports;
